/*eslint-disable*/
import React, { useState, useEffect } from "react";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';

import APIClient from "../client";
import config from "../config.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";

import CardError from "../components/Cards/CardError.js";


import '../assets/styles/App.css';
import "@fontsource/montserrat";


const client = new APIClient(config);


export default function Segmentation() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [settings, setSettings] = useState({});


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await client.getSegmentation();

        if (response.status !== 200) {
          throw new Error(`HTTP error: Status ${response.status}`);
        }

        setData(response['data']['data']);

        setError(null);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const screenSize = (window.innerWidth >= 768);
  document.title = "Segmentation";

  return (
    <>
      <section>
        <AuthNavbar />
      </section>

      <section className="relative grad-1 pb-20">
        <div className="container relative mx-auto pt-12 px-4 w-10/12">

          {loading && (
            <div className="text-xl text-yellow font-medium">Loading...</div>
          )}
          {error && <CardError message={error} />}

          {data && (

            <>
              <h2 className="text-36 text-yellow mb-6">Customer Segmentation</h2>
              <p className="text-20-30 text-white">
                A overview customer segmentation and remaining opportunities.
              </p>

              <div className="w-full h-screen">

                <div className="relative w-full px-4 mb-8">
                  <div className="relative bg-white-7 w-full rounded-lg p-4 mb-8">
                    <PivotTableUI
                      data={data}
                      onChange={(s) => setSettings(s)}
                      {...settings}
                      // cols={["loan_segment"]}
                      // rows={["loan_number_segment"]}
                      hiddenAttributes={["id", "updated_at"]}
                      hiddenFromDragDrop={["customer_count"]}
                      vals={["customer_count"]}
                      aggregatorName="Integer Sum"
                    />
                  </div>
                </div>




              </div>





            </>




          )}

        </div>

      </section>

    </>
  );

}